export const enum AbilityDimensionFlags {
	ADD = 1,
	EDIT = 1 << 2,
	VIEW = 1 << 3,
	AUDIT = 1 << 4,
}
export type AbilityDimensionFlagsType = keyof typeof AbilityDimensionFlags
export type AbilityDimensionFlagsValue = typeof AbilityDimensionFlags[AbilityDimensionFlagsType]

export enum AbilityDimensionStatus {
	'启用' = 'enable',
	'禁用' = 'disable',
}

export type AbilityDimensionStatusType = keyof typeof AbilityDimensionStatus
export type AbilityDimensionStatusValue = typeof AbilityDimensionStatus[AbilityDimensionStatusType]

// unlockStatus	string 锁状态 三种 未解锁:lock;家长锁:parentUnLock;教师锁:teacherUnLock
export enum AbilityPointStatus {
	'未解锁' = 'lock',
	'家长锁' = 'parentUnLock',
	'教师锁' = 'teacherUnLock',
}

export type AbilityPointStatusType = keyof typeof AbilityPointStatus
export type AbilityPointStatusValue = typeof AbilityPointStatus[AbilityPointStatusType]

// 评分
export enum AbilityPointScore {
	'0分' = 0,
	'1分' = 1,
	'2分' = 2,
}

export type AbilityPointScoreType = keyof typeof AbilityPointScore
export type AbilityPointScoreValue = typeof AbilityPointScore[AbilityPointScoreType]
